import { observable } from "mobx";
import { api, apiOperacao } from "../../api";
import { toast } from "react-toastify";
import { decodeUtf8String, downloadBinaryFile } from "../../utils";
import { IEmpresa } from "../../model";
import { ReturnCalcsEmpresa } from "../../components/contestar/calcs_options";

export class _AcumuladoresStore {

  obs = observable({
    acumuladores: [],
    filter_calculo: "",
    filter_acumulador: "",
    acumuladores_current: 1,
    acumuladores_length: 0,

    calcs: [],

  })

  async handleBuscaAcumuladores(page: number, cnpj: string, uf: string, calculo: string, acumulador: string) {

    try {

      let params = {
        page: page,
        limit: 20,
        acumulador: acumulador,
        calculo: calculo,
        cnpj: cnpj,
        uf: uf
      }
      let resp = await apiOperacao("sped").post('/sped/acumuladores/index', params)

      this.obs.acumuladores_length = 0
      this.obs.acumuladores = []

      if (resp.data.itens.length > 0) {
        this.obs.acumuladores = resp.data.itens
        this.obs.acumuladores_length = resp.data.count
      }

    } catch (ex) { }

  }

  async handleCreateAcumulador(params: any) {

    try {

      let resp = await apiOperacao("sped").post('/sped/acumuladores/create', params)

      if (resp.status == 200) return resp.data

    } catch { }

    return null

  }

  async handleUpdateAcumulador(params: any) {

    try {

      let resp = await apiOperacao("sped").post('/sped/acumuladores/update', params)

      if (resp.data.ok == true) {

        toast.success('Acumulador atualizado com sucesso.', {});

        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

    return false

  }

  async handleDeleteAcumulador(id: string) {

    try {

      let resp = await apiOperacao("sped").delete(`/sped/acumuladores/${id}`)

      if (resp.data.ok == true) {

        toast.success('Acumulador deletado com sucesso.', {});

        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

    return false

  }

  async handleCalcsLoad(empresa: IEmpresa) {

    try {

      let data = {
        uf: empresa.uf,
        simples_nacional: (empresa.simples_nacional ?? false),
        simples_nacional_excesso: (empresa.simples_nacional_excesso ?? false),
        regime_especial_icms_pa: (empresa.regime_especial_icms_pa ?? false)
      }

      let resp = await apiOperacao("sped").post(`/sped/calcs`, data)

      this.obs.calcs = [];

      if (resp.status === 200) {

        this.obs.calcs = resp.data

      }

    } catch { }

  }

  async handleExportCalculos(empresa: IEmpresa) {

    try {

      let data = {
        uf: empresa.uf,
        simples_nacional: (empresa.simples_nacional ?? false),
        simples_nacional_excesso: (empresa.simples_nacional_excesso ?? false),
        regime_especial_icms_pa: (empresa.regime_especial_icms_pa ?? false)
      }

      let resp = await apiOperacao("sped").post(`/sped/calcs/export`, data,
        { responseType: 'blob' }
      );

      if (resp.status == 200) {

        const fileName = "export_calculos.xlsx";

        downloadBinaryFile(resp.data, fileName)

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch { }

  }

  async handleImportAcumuladores(formData) {

    try {

      let resp = await apiOperacao("sped").post("/sped/acumuladores/import", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });

      if (resp.data.ok) {

        return resp.data

      } else {

        toast.error(resp.data.error || "Erro na importação.");

      }

    } catch (ex) { }

    return []

  }

  async handleDuplicarAcumuladores(params: any) {

    try {

      let resp = await apiOperacao("sped").post('/sped/acumuladores/duplicate', params)

      if (resp.data.ok) {

        return resp.data

      } else {

        toast.error(resp.data.error || "Erro na importação.");

      }

    } catch { }

    return []

  }

  async handleDeleteAll(cnpj: string) {

    try {

      let resp = await apiOperacao("sped").delete(`/sped/acumuladores/delete/${cnpj}`)

      if (resp.data.ok) {

        toast.success('Acumuladores deletados com sucesso.', {});

        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

    return false

  }

  async handleExportAcumuladores(cnpj: string, uf: string) {

    try {

      let data = {
        cnpj,
        uf
      }

      let resp = await apiOperacao("sped").post(`/sped/acumuladores/export`, data,
        { responseType: 'blob' }
      );

      if (resp.status == 200) {

        const fileName = cnpj + "_acumuladores.xlsx";

        downloadBinaryFile(resp.data, fileName)

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch { }

  }

}

export const AcumuladoresStore = new _AcumuladoresStore();
